import { WidgetType } from 'shared/widgets/utils';

import { createNewFlexSectionData } from './create';
import { manifestLocales } from './manifest.locales';
import FlexHorizontalSectionEn from './resources/en/rectangle-horizontal.svg';
import FlexVerticalSectionEn from './resources/en/rectangle-vertical.svg';
import FlexHorizontalSectionHe from './resources/he/rectangle-horizontal.svg';
import FlexVerticalSectionHe from './resources/he/rectangle-vertical.svg';
import { FlexSectionDirection } from './types';
import { HorizontalObject } from '@/icons/HorizontalObject';
import { VerticalObject } from '@/icons/VerticalObject';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.FlexSection,
  previewGroups: [
    {
      id: 'row',
      divider: {
        icon: HorizontalObject,
        title: 'row'
      },
      previews: [
        {
          name: 'flexHorizontalSectionPreview',
          previewImage: {
            paths: {
              en: FlexHorizontalSectionEn,
              he: FlexHorizontalSectionHe
            },
            alt: { ...manifestLocales.main.previewImageAlt },
            size: {
              width: 285,
              height: 140
            }
          },
          initializeProps: () => createNewFlexSectionData(FlexSectionDirection.row),
          dimensions: {
            width: 600,
            height: 'auto'
          }
        }
      ]
    },
    {
      id: 'column',
      divider: {
        icon: VerticalObject,
        title: 'column'
      },
      previews: [
        {
          name: 'flexVerticalSectionPreview',
          previewImage: {
            paths: {
              en: FlexVerticalSectionEn,
              he: FlexVerticalSectionHe
            },
            alt: { ...manifestLocales.main.previewImageAlt },
            size: {
              width: 285,
              height: 140
            }
          },
          initializeProps: () => createNewFlexSectionData(FlexSectionDirection.column),
          dimensions: {
            width: 600,
            height: 'auto'
          }
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
